import { useContext, useRef, useState, useMemo, useEffect } from "react";
import DeclarationContext from "../../../context/declaration/DeclarationContext";
import ThemeContext from "../../../context/theme/ThemeContext";
import NotificationsOverlay from "./NotificationsOverlay";
import { PiBell } from "react-icons/pi";
import Badge from "../../common/Badge";

const NotificationsButton = () => {
	const { withTheme } = useContext(ThemeContext);
	const { listDeclarations, state } = useContext(DeclarationContext);
	const [notificationsOverlay, setNotificationsOverlay] = useState(false);
	const notificationsOverlayTarget = useRef(null);

	const notifications = useMemo(() => {
		let notifications = [];
		state.declarations.forEach((declaration, index) => {
			let totalCount = 0;
			const declarationNotifications = declaration?.jdeclaration?.data?.notifications || [];

			declarationNotifications.forEach((notification) => {
				totalCount = totalCount + 1 + (notification.uIElements?.length || 0);
			});

			if (totalCount) {
				notifications.push({
					message: `**Declaration #${index + 1}** has ${totalCount} new notifications`,
					route: `/declarations?creationTime=${declaration.creationTime}`,
					processedTime: declarationNotifications[0].processedTime,
				});
			}
		});
		return notifications.sort((a, b) => (a.processedTime > b.processedTime ? -1 : 1));
	}, [state.declarations]);

	useEffect(() => {
		if (!state.declarationsLoading && !state.declarations.length) {
			listDeclarations();
		}
	}, []);

	return (
		<div className={withTheme("notification-button")}>
			<NotificationsOverlay
				target={notificationsOverlayTarget}
				open={notificationsOverlay}
				notifications={notifications}
				handleClose={() => setNotificationsOverlay(false)}
			/>

			<div
				ref={notificationsOverlayTarget}
				style={{
					position: "relative",
				}}
			>
				<Badge count={notifications.length}>
					<div style={{ display: "flex" }} onClick={() => setNotificationsOverlay(true)}>
						<PiBell fontSize={24} />
					</div>
				</Badge>
			</div>
		</div>
	);
};

export default NotificationsButton;
